export const DEFAULT_PROFILE_AVATAR = '/bm01.png';

export const PROFILES_GATE_REDIRECT_PATH = '/movies';
